export const SAXENDA = 'saxenda';
export const WEGOVY = 'wegovy';
export const MOUNJARO = 'mounjaro';
